import { create } from "zustand";
import { handlePasswordUpdate } from "../../apiEndpoints/navutils";

type UpdatePasswordState = {
    oldPassword: string;
    newPassword: string;
    confirmNewPassword: string;
    showSpinner: boolean,
    showOldPassword: boolean;
    showNewPassword: boolean;
    showConfirmedPassword: boolean;

    setOldPassword: (value: string) => void;
    setNewPassword: (value: string) => void;
    setConfirmNewPassword: (value: string) => void;

    toggleShowOldPassword: () => void;
    toggleShowNewPassword: () => void;
    toggleShowConfirmedPassword: () => void;
    handleSubmit: (taskFinished: () => void) => void;
    toggleSpineer: () => void
};



export const useUpdatePasswordStore = create<UpdatePasswordState>((set) => ({
    showSpinner: false,
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: "",

    showOldPassword: false,
    showNewPassword: false,
    showConfirmedPassword: false,

    setOldPassword: (value: string) => set({ oldPassword: value }),
    setNewPassword: (value: string) => set({ newPassword: value }),
    setConfirmNewPassword: (value: string) => set({ confirmNewPassword: value }),

    toggleShowOldPassword: () =>
        set((state) => ({ showOldPassword: !state.showOldPassword })),
    toggleShowNewPassword: () =>
        set((state) => ({ showNewPassword: !state.showNewPassword })),
    toggleShowConfirmedPassword: () =>
        set((state) => ({ showConfirmedPassword: !state.showConfirmedPassword })),

    handleSubmit: async (taskFinished) => {
        const state = useUpdatePasswordStore.getState();
        set({ showSpinner: true })
        const result = await handlePasswordUpdate(
            "update", state.newPassword, state.confirmNewPassword, state.oldPassword
        );
        set({ showSpinner: false })
        if (result) {
            taskFinished();
        }
    },
    toggleSpineer: () =>
        set((state) => ({ showSpinner: !state.showSpinner }))
}));